<template>
  <div id="app">
  <!-- <router-view v-if='isRouterAlive'/> -->
  <keep-alive>

      <router-view v-if="$route.meta.keepAlive"></router-view>
  </keep-alive>
  <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";

export default {
  name: 'App',
  components: {},
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive =false
      this.$nextTick(function(){
        this.isRouterAlive =true
      })
    },
    setBrowserIcon: function()
    {
      var link = document.querySelector("link[rel~='icon']");
      var tenant = window.location.hostname.split('.').join("-");
      tenant = tenant.substr(0, tenant.indexOf('-'));

      if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = './static/img/favicon.ico';
    },
    title: function()
    {
      var tenant = window.location.hostname.split('.')[0].split("unifiproperty")[0].split("dashboard")[0]
      document.title = tenant.toUpperCase()==""?"UNIFI":tenant.toUpperCase();
    }
  },
  beforeMount(){
    this.setBrowserIcon()
    this.title()
  },
}
</script>

<style>
#app {
    position: relative;
    height: 100%;
    min-width: 1280px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue